import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";
import securityOptions from "@/store/securityOptions";
// const BASE_URL = "https://dxsurveyapi.chedroxi.com/api";
const BASE_URL = "http://localhost:8000/api";

Vue.use(Vuex);
const ls = new SecureLS(securityOptions);
let Store;

try {
  Store = new Vuex.Store({
    state: {
      // APP_BASE_URL: 'https://dxsurveyapi.chedroxi.com',
      APP_BASE_URL: 'http://localhost:8000',
      Sidebar_drawer: null,
      Customizer_drawer: false,
      SidebarColor: "white", //Change Sidebar Color || 'white', | "#2b2b2b" | "rgb(44, 59, 164)" | "rgb(96, 44, 164)" | "rgb(151, 210, 219)" | "rgb(77, 86, 100)"
      SidebarBg: "",
      navbarColor: "primary",
      setHorizontalLayout: true, // Horizontal layout
      navigationButtons: {
        section_1: {
          previous: "",
          next: "",
        },
        section_2: {
          previous: "",
          next: "",
        },
        section_3: {
          previous: "",
          next: "",
        },
        section_4: {
          previous: "",
          next: "",
        },
        section_5: {
          previous: "",
          next: "",
        },
        section_6: {
          previous: "",
          next: "",
        },
        section_7: {
          previous: "",
          next: "",
        }
      },
      active_tab: 0,
      rendered_component: null,

      user: {
        user_roles: [],
      },
      loading: false,
      is_authenticated: false,
      token: [],
      formData: {},
      disclaimer_agreed: false,
    },
    mutations: {
      SET_SIDEBAR_DRAWER(state, payload) {
        state.Sidebar_drawer = payload;
      },
      SET_CUSTOMIZER_DRAWER(state, payload) {
        state.Customizer_drawer = payload;
      },
      SET_SIDEBAR_COLOR(state, payload) {
        state.SidebarColor = payload;
      },
      SET_NAVBAR_COLOR(state, payload) {
        state.navbarColor = payload;
      },
      SET_LAYOUT(state, payload) {
        state.setHorizontalLayout = payload;
      },
      
      setRenderedComponent(state, payload){
        state.rendered_component = payload;
      },
      
      setRequestHeader(state, payload){
        axios.defaults.headers.common["Authorization"] = `Bearer ${payload}`;
      },
      CLEAR_CREDENTIALS(state){
        state.is_authenticated = false;
        state.user = {
          user_roles: [],
        },
        setTimeout(() => {
          state.Sidebar_drawer = null
          state.Customizer_drawer = false;
          state.SidebarColor = "white";
          state.SidebarBg = "";
          state.navbarColor = "primary";
          state.setHorizontalLayout = true;
          state.navigationButtons = {
            section_1: {
              previous: "",
              next: "",
            },
            section_2: {
              previous: "",
              next: "",
            },
            section_3: {
              previous: "",
              next: "",
            },
            section_4: {
              previous: "",
              next: "",
            },
            section_5: {
              previous: "",
              next: "",
            },
            section_6: {
              previous: "",
              next: "",
            },
            section_7: {
              previous: "",
              next: "",
            }
          },
          state.active_tab = 0;
          state.rendered_component = null;
          state.loading = false;
          state.is_authenticated = false;
          state.token = [];
          state.formData = Object.assign({}, {});
        }, 800);
      },
      SET_NAVIGATION_BUTTONS(state, payload){
        let section = payload.section;
        switch (section) {
          case 1:
            state.navigationButtons.section_1.previous = payload.previous;
            state.navigationButtons.section_1.next = payload.next;
            break;

          case 2:
            state.navigationButtons.section_2.previous = payload.previous;
            state.navigationButtons.section_2.next = payload.next;
            break;

          case 3:
            state.navigationButtons.section_3.previous = payload.previous;
            state.navigationButtons.section_3.next = payload.next;
            break;

          case 4:
            state.navigationButtons.section_4.previous = payload.previous;
            state.navigationButtons.section_4.next = payload.next;
            break;

          case 5:
            state.navigationButtons.section_5.previous = payload.previous;
            state.navigationButtons.section_5.next = payload.next;
            break;

          case 6:
            state.navigationButtons.section_6.previous = payload.previous;
            state.navigationButtons.section_6.next = payload.next;
            break;

          case 7:
            state.navigationButtons.section_7.previous = payload.previous;
            state.navigationButtons.section_7.next = payload.next;
            break;
        
          default:
            break;
        }
      },
      SET_ACTIVE_TAB(state, payload){
        state.active_tab = payload;
      },
      IS_AUTHENTICATED(state, payload){
        state.is_authenticated = payload;
      },
      SET_TOKEN(state, payload){
        state.token = payload;
      },
      SET_USER_PROFILE(state, payload){
        state.user = payload;
      },
      SET_USER_PHOTO(state, payload){
        if(state.user){
          state.user.photo = payload;
        }
      },
      SET_FORM_DATA(state, payload){
        state.formData = Object.assign({}, payload)
      },
      SET_DISCLAIMER_RESPONSE(state, payload){
        state.disclaimer_agreed = payload;
      }
    },
    
    actions: {
      /**
       * Authentication Starts
       */
      signIn(context, payload){
        return new Promise((resolve, reject) => {
          setTimeout(() => {
            axios.post(`${BASE_URL}/user/auth/signin`, payload)
            .then((response) => {
              context.commit('isAuthenticated', true);
              context.commit('setToken', response.data);
              resolve(response);
            })
            .catch((error) => {
              context.commit('isAuthenticated', false);
              reject(error);
            })
          }, 1000)
        })
      },
  
      async signingIn({dispatch},payload){
        await dispatch('signIn', payload);
      },

      signOut({commit, getters}){
        return new Promise((resolve, reject) => {
          axios.post(`${BASE_URL}/user/auth/signout`, null , { headers: {"Authorization" : `Bearer ${getters.token.access_token}`}})
          .then((response) => {
            commit('CLEAR_CREDENTIALS');
            resolve(response);
          })
          .catch((error) => {
            commit('CLEAR_CREDENTIALS');
            reject(error);
          });
        })
      },
      /**
       * Authentication Ends
       */

  
      downloadFile(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.get(`${BASE_URL}/app/file/get`,{
            responseType: 'blob',
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
      

      /*** Getting Current User Info */
      getUserProfile(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.get(`${BASE_URL}/app/user/auth/profile/get`)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
      /** * Getting Current User Info Ends */


      getFormData(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.get(`${BASE_URL}/app/form/data/get`)
          .then((response) => {
            context.commit('SET_FORM_DATA', response.data);
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },


      updateInstitutionProfileSection1(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/institution/profile/section1/update`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      saveSUCLevelling(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/form/suc_levelling/store`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      saveSection1Response(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/form/section/1/save`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

  
      /** User Accounts Start */
      getUserAccounts(context){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.get(`${BASE_URL}/app/users/accounts/get`)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      deactivateUserAccount(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/users/accounts/deactivate/${payload.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
  
      assignDomain(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/users/accounts/domain/assign`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
  
      detachAssignedDomain(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/users/accounts/domain/detach`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
  
      activateUserAccount(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/users/accounts/activate/${payload.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
  
      approveUserAccount(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/users/accounts/approve/${payload.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
  
      disapproveUserAccount(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/users/accounts/disapprove/${payload.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
  
      bulkApproveUserAccount(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/users/accounts/bulk/approve`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
  
  
      bulkDisapproveUserAccount(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/users/accounts/bulk/disapprove`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
  
  
      bulkDeactivateUserAccount(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/users/accounts/bulk/terminate`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
  
      updateUserAccount(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/users/accounts/update`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
  
      completeRegistration(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/users/accounts/complete/registration`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
  
      storeUserAccount(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/users/accounts/store`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
      /** User Accounts End */



      /**
       **Leadership and Governance Response Controllers
       */
       getResponse_1_1(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.get(`${BASE_URL}/app/form/domain_1/q_1/response/get`)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      saveReponse_1_1(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/form/domain_1/q_1/response/store`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      getResponse_1_2(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.get(`${BASE_URL}/app/form/domain_1/q_2/response/get`)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      saveReponse_1_2(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/form/domain_1/q_2/response/store`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },


      getResponse_1_3(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.get(`${BASE_URL}/app/form/domain_1/q_3/response/get`)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      saveReponse_1_3(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/form/domain_1/q_3/response/store`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      getResponse_1_4(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.get(`${BASE_URL}/app/form/domain_1/q_4/response/get`)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      saveReponse_1_4(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/form/domain_1/q_4/response/store`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      getResponse_1_5(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.get(`${BASE_URL}/app/form/domain_1/q_5/response/get`)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      saveReponse_1_5(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/form/domain_1/q_5/response/store`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },


      getResponse_1_6(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.get(`${BASE_URL}/app/form/domain_1/q_6/response/get`)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      saveReponse_1_6(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/form/domain_1/q_6/response/store`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      getResponse_1_7(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.get(`${BASE_URL}/app/form/domain_1/q_7/response/get`)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      saveReponse_1_7(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/form/domain_1/q_7/response/store`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },


      getResponse_1_8(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.get(`${BASE_URL}/app/form/domain_1/q_8/response/get`)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      saveReponse_1_8(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/form/domain_1/q_8/response/store`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      getResponse_1_9(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.get(`${BASE_URL}/app/form/domain_1/q_9/response/get`)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      saveReponse_1_9(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/form/domain_1/q_9/response/store`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      getResponse_1_10(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.get(`${BASE_URL}/app/form/domain_1/q_10/response/get`)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      saveReponse_1_10(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/form/domain_1/q_10/response/store`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      getResponse_1_11(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.get(`${BASE_URL}/app/form/domain_1/q_11/response/get`)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      saveReponse_1_11(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/form/domain_1/q_11/response/store`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },


      getResponse_1_12(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.get(`${BASE_URL}/app/form/domain_1/q_12/response/get`)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      saveReponse_1_12(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/form/domain_1/q_12/response/store`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      getResponse_1_13(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.get(`${BASE_URL}/app/form/domain_1/q_13/response/get`)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      saveReponse_1_13(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/form/domain_1/q_13/response/store`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },


      removeInformationSystemInResponse_2(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/form/domain_2/q_10/response/information_system/delete/${payload.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      removeDatabaseInResponse_2(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/form/domain_2/q_11/response/database/delete/${payload.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },


      removeItemFromOthersInResponse_2(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/form/domain_2/q_12/response/others/delete/${payload.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      removeItemFromOthersInResponse_2_3_6(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/form/domain_2/q_13/response/others/delete/${payload.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      removeItemFromOthersInResponse_2_3_7(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/form/domain_2/q_14/response/others/delete/${payload.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },


      getResponse_2(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.get(`${BASE_URL}/app/form/domain_2/${payload.q}/response/get`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      saveReponse_2(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/form/domain_2/${payload.q}/response/store`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },



      getResponse_3(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.get(`${BASE_URL}/app/form/domain_3/${payload.q}/response/get`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      saveReponse_3(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/form/domain_3/${payload.q}/response/store`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },


      getResponse_4(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.get(`${BASE_URL}/app/form/domain_4/${payload.q}/response/get`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      saveReponse_4(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/form/domain_4/${payload.q}/response/store`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },


      getResponse_5(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.get(`${BASE_URL}/app/form/domain_5/${payload.q}/response/get`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      saveReponse_5(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/form/domain_5/${payload.q}/response/store`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },



      getResponse_6_1(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.get(`${BASE_URL}/app/form/domain_6/q_1/response/get`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      saveReponse_6_1(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/form/domain_6/q_1/response/store`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      getResponse_6_2(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.get(`${BASE_URL}/app/form/domain_6/q_2/response/get`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      saveReponse_6_2(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/form/domain_6/q_2/response/store`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      getResponse_6_3(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.get(`${BASE_URL}/app/form/domain_6/q_3/response/get`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      saveReponse_6_3(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/form/domain_6/q_3/response/store`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      getResponse_6_5(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.get(`${BASE_URL}/app/form/domain_6/q_5/response/get`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      saveReponse_6_5(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/form/domain_6/q_5/response/store`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      getResponse_6(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.get(`${BASE_URL}/app/form/domain_6/${payload.q}/response/get`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      saveReponse_6(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/form/domain_6/${payload.q}/response/store`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      getResponse_7_1(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.get(`${BASE_URL}/app/form/domain_7/q_1/response/get`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      saveReponse_7_1(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/form/domain_7/q_1/response/store`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      getResponse_7_2(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.get(`${BASE_URL}/app/form/domain_7/q_2/response/get`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      saveReponse_7_2(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/form/domain_7/q_2/response/store`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      getResponse_7_3(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.get(`${BASE_URL}/app/form/domain_7/q_3/response/get`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      saveReponse_7_3(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/form/domain_7/q_3/response/store`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      getResponse_7_4(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.get(`${BASE_URL}/app/form/domain_7/q_4/response/get`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      saveReponse_7_4(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/form/domain_7/q_4/response/store`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },


      /**
       ** Leadership and Governance Response Controller Ends
       */


      /**
       ** Data Statistics
       */
   
       getStatistics(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.get(`${BASE_URL}/app/stats/data/get`, { params: payload })
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },

      /**
       ** Data Statistics Ends
       */


       /**
        ** Responses Export
        */
  
        exportResponses(context, payload){
          context.commit('setRequestHeader', context.getters.token.access_token);
          return new Promise ((resolve, reject) => {
            axios.get(`${BASE_URL}/app/responses/data/export`,{
              responseType: 'blob',
            })
            .then((response) => {
              resolve(response);
            })
            .catch((error)=>{
              reject(error);
            });
          });
        },



      /**
       ** Responses Export Ends
       */
    },
  
    getters: {
      getNavigationButtons(state){
        return state.navigationButtons;
      },

      getRenderedComponent(state){
        return state.rendered_component;
      },
      
      getActiveTab(state){
        return state.active_tab;
      },

      APP_BASE_URL(state){
        return state.APP_BASE_URL;
      },
      IS_AUTHENTICATED(state){
        return state.is_authenticated;
      },
      token(state){
        return state.token;
      },
      GET_FORM_DATA(state){
        return state.formData;
      },
      GET_USER(state){
        return state.user;
      },
      GET_DISCLAIMER_RESPONSE(state){
        return state.disclaimer_agreed;
      },
    },
  
      
    plugins: [
      createPersistedState({
        storage: {
          getItem: key => ls.get(key),
          setItem: (key, value) => ls.set(key, value),
          removeItem: key => ls.remove(key)
        }
      })
    ]
  });
} catch (error) {
  window.localStorage.clear();
}


export default Store;